import { MOBILE_DIMENSIONS } from '../constants';

export const basicTemplate = {
  name: "Basic Layout",
  elements: [
    {
      type: 'text',
      identifier: 'eventName',
      content: 'Event Name',
      x: MOBILE_DIMENSIONS.width / 2 - 150,
      y: 50,
      width: 300,
      height: 60,
      fontSize: 28,
      fontFamily: 'Montserrat',
      fontStyle: 'bold',
      color: '#1a1a1a'
    },
    {
      type: 'text',
      identifier: 'dateTime',
      content: 'Date and Time',
      x: MOBILE_DIMENSIONS.width / 2 - 125,
      y: 130,
      width: 250,
      height: 40,
      fontSize: 20,
      fontFamily: 'Lato',
      color: '#333333'
    },
    {
      type: 'text',
      identifier: 'address',
      content: 'Venue Address',
      x: MOBILE_DIMENSIONS.width / 2 - 150,
      y: 190,
      width: 300,
      height: 60,
      fontSize: 18,
      fontFamily: 'Poppins',
      color: '#4a4a4a'
    },
    {
      type: 'text',
      identifier: 'contactInfo',
      content: 'Contact Information',
      x: MOBILE_DIMENSIONS.width / 2 - 125,
      y: 270,
      width: 250,
      height: 40,
      fontSize: 16,
      fontFamily: 'Lato',
      color: '#666666'
    },
    {
      type: 'text',
      identifier: 'bankDetails',
      content: 'Bank Details',
      x: MOBILE_DIMENSIONS.width / 2 - 150,
      y: 330,
      width: 300,
      height: 80,
      fontSize: 16,
      fontFamily: 'Poppins',
      color: '#4a4a4a'
    },
    {
      type: 'image',
      identifier: 'bankQR',
      src: '',
      x: MOBILE_DIMENSIONS.width / 2 - 75,
      y: 430,
      width: 150,
      height: 150
    },
    {
      type: 'text',
      identifier: 'mapEmbed',
      content: 'Location',
      x: MOBILE_DIMENSIONS.width / 2 - 150,
      y: 600,
      width: 300,
      height: 200,
      fontSize: 16,
      fontFamily: 'Lato',
      color: '#333333'
    }
  ]
};